import ArticleLayout from '@/components/feature/ArticleLayout';
import { articlesBySlug } from '@/mocks/articles';

export default function KakobuySpreadsheetPoradnik() {
  return <ArticleLayout article={articlesBySlug['kakobuy-spreadsheet-poradnik']} />;
}